import { type Optional, utils } from 'apprise-core/utils'
import { useLanguage } from 'apprise-frontend-core/intl/language'
import { useMultilang } from 'apprise-frontend-core/intl/multilang'

import { noTenant } from 'apprise-core/tenant'
import { unknownUserId, User, UserReference } from 'apprise-core/user'
import { useTenantStore } from 'apprise-frontend-iam/tenant/store'
import { useUserExcludes } from 'apprise-frontend-iam/user/context'



export const useNewUser = () => {

  const { isExcluded } = useUserExcludes()

  return (tenant: string): User => {

    return {

      username: undefined!,
      tenant,
      guarded: false,
      lifecycle: { state: isExcluded('active') ? 'active' : 'inactive' },
      details: {
        firstname: undefined!,
        lastname: undefined!,
        email: undefined!,
        preferences: {
          accountState: 'none'
        }
      },
      tags: [],
      permissions: []

    }

  }

}

export const useUnknownUser = () => {

  const newUserIn = useNewUser()

  return (username?: Optional<UserReference>): User => ({

    ...newUserIn(noTenant),

    username: unknownUserId,
    lifecycle: {
      state: 'active'
    },
    details: {
      firstname: undefined!,
      lastname: username || undefined!,
      email: undefined!,
      preferences: {}
    }

  })
}



export const useUserModel = () => {

  const {join} = useMultilang()
  const lang = useLanguage()
  const tenantStore = useTenantStore()
  const unknownUser = useUnknownUser()

  const self = {

    textOf: (t: Optional<User>) => join(t ? [t.username, self.fullName(t)] : []),

    unknownUser

    ,

    fullName: (u: Optional<User>) => u ? `${u?.details.firstname ?? ''} ${u?.details.lastname ?? ''}`.trim() : undefined

    ,

    clone: (u: User): User => ({ ...utils().deepclone(u), username: undefined!, lifecycle: { state: 'inactive' } })


    ,

    defaultLanguage: (user: User) => user.tenant === noTenant ? lang.default() : tenantStore.safeLookup(user.tenant).preferences.language ?? lang.default()

    ,


    preferredLanguage: (user: User) => user.details?.preferences.language ?? self.defaultLanguage(user)

    ,

    comparator: (u1: Optional<User>, u2: Optional<User>) => self.fullName(u1)?.localeCompare(self.fullName(u2) ?? '') ?? -1

  }

  return self
}